module.exports = __webpack_public_path__ + "static/img/j-3.f4a1e089.png";